module.exports = __webpack_public_path__ + "img/testimonials_stacked.b9584da3.png";